import { useEffect } from "react";
import Logo from "@/components/landing/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CallbackPage = () => {
  useEffect(() => {
    document.title = "Fullfører BankID-innlogging – Rstrøm";
    // Signicat sender code/state hit (frontend-route) – videresend til backend for tokenutveksling
    window.location.replace(`${API}/auth/bankid/callback${window.location.search}`);
  }, []);

  return (
    <div
      className="min-h-screen bg-[#F8FAFC] flex flex-col items-center justify-center gap-8 px-6"
      data-testid="bankid-callback-page"
    >
      <Logo />
      <div className="w-12 h-12 border-4 border-slate-200 border-t-emerald-500 rounded-full animate-spin" />
      <p className="text-slate-600 text-sm font-medium">Fullfører BankID-innloggingen …</p>
    </div>
  );
};

export default CallbackPage;
